export default __webpack_public_path__ + "static/media/brooke-lark-M4E7X3z80PQ-unsplash.f561d10e.jpg";